import React, { useCallback, useMemo, useState,useEffect } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  TextField,
  IconButton,
  Button,
  Autocomplete,
  Checkbox,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
   Select,             
  MenuItem, 
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import GroupsIcon from "@mui/icons-material/Groups";
import SelectAllIcon from "@mui/icons-material/Groups";

import PaidIcon from "@mui/icons-material/Paid";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Tooltip } from "@mui/material";

import EditTotalTransportationDialog from "../components/EditTotalTransportationDialog";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { px } from "framer-motion";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import AssessmentIcon from "@mui/icons-material/Assessment";
// to navigate to the Visit report page 
import { useNavigate } from "react-router-dom";

import DoneAllIcon from "@mui/icons-material/DoneAll";

import { useLocation } from "react-router-dom";
import { AccountingUid } from "../components/constants";

import { SupervisorUid } from "../components/constants";

import { getDeviceStationId ,isRealPhone} from "../utils/global_functions";

// to be responsive for mobile
import { useTheme, useMediaQuery } from "@mui/material";

//! after adding orgname add this to the fetch function and axios ! 
import { apiFetch } from "../utils/apiFetch"; 





//Actions!! 
const STATUS_CONFIG = {
  0: { label: "Unsubmitted",    color: "default", variant: "outlined" },
  1: { label: "Pending",  color: "warning", variant: "filled"   },
  2: { label: "Approved", color: "success", variant: "filled"   },
  3: { label: "Rejected", color: "error",   variant: "filled"   },
  4: { label: "Paid",     color: "success", variant: "filled"   },
  5: { label: "Partial", color: "info", variant: "filled" }
};



//for url format 
const normalizeBaseUrl = (raw) => {
    if (!raw) return "";
    const trimmed = raw.trim().replace(/\/$/, "");
    if  (/^https?:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
};

export default function VisitHistoryPage() {

  // mobile responsive
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Detecr HR MOde 
  //location == url info 
  const location = useLocation();
  ///home/calendar/visits?hr=true
  const isHrMode = new URLSearchParams(location.search).get("hr") === "true"
    && AccountingUid.includes(localStorage.getItem("saved_username") || "");

  // Summary chips, same idea as AllAttendancePage's "Employees" /
  // "Any Vacation" counters at the top of the card.
 const [visits, setVisits] = useState([]);
 const [loading, setLoading] = useState(true);
 const [loadError, setLoadError] = useState("");

 const[editingRow, setEditingRow] = useState(null);
 const[editValues,setEditValues] = useState({ amount:"", km: "", parking: "" ,comment:""});
 const[saving, setSaving] = useState(false);

 const [totalDialogOpen, setTotalDialogOpen] = useState(false);
 const [totals, setTotals] = useState([]);
 
 //to filter the current month 
 const today = dayjs();
 const [selectedDate, setSelectedDate]= useState( dayjs(`${today.year()}-${today.month() + 1}-01`));
// Fetch employee incase HrMode
 const [employees, setEmployees]= useState([]);
 const [selectedEmpId, setSelectedEmpId]= useState(
   isHrMode ? null : localStorage.getItem("shared_empid")
 );

 // array created to store ID(entryNo) of each checked row !!
 const [selectedIds, setSelectedIds]= useState([]);

 //array to store entryNo of each checked total trasportation
 const [selectedTotalIds, setSelectedTotalIds] = useState([]);

//submit visit from employee to supervisor !!
 const [submitting, setSubmitting]= useState(false);
 const [snack, setSnack]= useState({ open: false, message: "", severity: "success"});

 //dialog when click submit for approval
const [confirmSubmitOpen, setConfirmSubmitOpen] = useState(false);

 const navigate= useNavigate();



// Fetch employee when HR Mode
// useEffect(() => {
//   if (!isHrMode) return;
//   const rawBase = localStorage.getItem("saved_sett_api_url");
//   const API_BASE_URL = normalizeBaseUrl(rawBase) || "http://localhost:5100";
//   fetch(`${API_BASE_URL}/api/employees`)
//     .then(res => res.json())
//     .then(data => setEmployees(Array.isArray(data.data) ? data.data : []))  // ← data.data not data
//     .catch(err => console.error("Failed to load employees:", err));
// }, [isHrMode]);

useEffect(() => {
  if (!isHrMode) return;
  const rawBase = localStorage.getItem("saved_sett_api_url");
  const API_BASE_URL = normalizeBaseUrl(rawBase) || "http://localhost:5100";

  apiFetch(`${API_BASE_URL}/api/employees?excludeUids=${SupervisorUid.join(",")}`)
    .then(res => res.json())
    .then(data => setEmployees(Array.isArray(data.data) ? data.data : []))
    .catch(err => console.error("Failed to load employees:", err));
}, [isHrMode]);





 // ── defined outside useEffect so it can be called on demand (e.g. after save) ──
const fetchHistory = useCallback(async () => {
  if (!selectedEmpId) return;  // don't fetch until an employee is selected
    setLoading(true);
    setLoadError("");
    setSelectedIds([]);  //<-- Clear checked rows on fresh load
    setSelectedTotalIds([]); 

    try {
      const rawBase = localStorage.getItem("saved_sett_api_url");
      const API_BASE_URL = normalizeBaseUrl(rawBase) || "http://localhost:5100";
      // const empId = localStorage.getItem("shared_empid");

      const month = selectedDate.month() +1;
      const year  = selectedDate.year();

      // visits
      const res = await apiFetch(`${API_BASE_URL}/api/visit/history?empId=${selectedEmpId}&month=${month}&year=${year}`);
      const data = await res.json();
      setVisits(Array.isArray(data) ? data : []);

      //totals
      const totalsRes = await apiFetch(`${API_BASE_URL}/api/visit/total?empId=${selectedEmpId}&month=${month}&year=${year}`);
      const totalsData = await totalsRes.json();
      setTotals(Array.isArray(totalsData) ? totalsData : []);

    } catch (err) {
      console.error("Failed to load:", err);
      setVisits([]);
      setTotals([]);
      setLoadError("Could not load data. Check your connection.");
    } finally {
      setLoading(false);
    }
}, [selectedDate, selectedEmpId]);


// ── runs once on mount ──
useEffect(() => {
    fetchHistory();
}, [fetchHistory]);


  // Summary chips, same idea as AllAttendancePage's "Employees" /
  // "Any Vacation" counters at the top of the card.
  const totalVisits = new Set(visits.map((v) => `${v.visitFrom}__${v.visitTo}__${v.date}`)).size;
  const totalAmount = useMemo(
    () => visits.reduce((sum, v) => sum + (Number(v.amount) || 0), 0),
    [visits]
  );
  const totalKm = useMemo(
    () => visits.reduce((sum, v) => sum + (Number(v.km) || 0), 0),
    [visits]
  );
  const totalParking = useMemo(
    () => visits.reduce((sum, v) => sum + (Number(v.parking) || 0), 0),
    [visits]
  );

  const amountByClient = useMemo(() => {
    const totals ={};
    visits.forEach((v) => {
      const name = `${v.visitFrom || ""} → ${v.visitTo || ""}` || "Unknown";
      const amt = Number(v.amount) || 0;
      totals[name] = (totals[name] || 0) + amt;
    });
    return totals;

  },[visits]);

  // calculate total of toal transportation 
   const totalAmountTransportation = useMemo(
    () => totals.reduce((sum, t) => sum + (Number(t.amount) || 0), 0),
    [totals]
  );
  const totalKmTransportation = useMemo(
    () => totals.reduce((sum, t) => sum + (Number(t.km) || 0), 0),
    [totals]
  );
  const totalParkingTransportation = useMemo(
    () => totals.reduce((sum, t) => sum + (Number(t.parking) || 0), 0),
    [totals]
  );


  const statusCount = useMemo(() => {
    const counts={ 0:0, 1:0, 2:0, 3:0, 4:0 };
    // loop through every visit in the data 
    visits.forEach((v) => {  
      const statusVal = v.status ?? 0;  // is status missing , default to draft (0)
      if (counts[statusVal] !==undefined){
        counts[statusVal]+=1;  //add to this specific status counter 
      }
    });
    return counts // return the final version of counts after adding 
  },[visits]);


  const monthStatus = useMemo(() => { //only recalculate this value when visits change 
  if (!visits.length) return null; // no visit return null 
  const statuses = visits.map((v) => v.status ?? 0); // walks through every visit row for status nb will be (ex:statuses = [0, 0, 1])
  return Math.max(...statuses); //lowest to highest 0(draft),1(pend),2(app),3(rej),4(paid)
}, [visits]);

// Same idea as statusCount/monthStatus, but for Total Transportation cards
const totalStatusCount = useMemo(() => {
  const counts = { 0:0, 1:0, 2:0, 3:0, 4:0 };
  totals.forEach((t) => {
    const statusVal = t.status ?? 0;
    if (counts[statusVal] !== undefined) counts[statusVal] += 1;
  });
  return counts;
}, [totals]);


  const conflictWarning = useMemo(() => {
  for (const visit of visits) {
    // check which fields are non-zero in this visit row
    const visitHasAmount  = visit.amount  > 0;
    const visitHasKm      = visit.km      > 0;
    const visitHasParking = visit.parking > 0;

    // if no values at all in this visit row, skip it
    if (!visitHasAmount && !visitHasKm && !visitHasParking) continue;

    for (const total of totals) {
      // check if this visit date falls within this total's range
      const visitDate = dayjs(visit.date);
      const fromDate  = dayjs(total.dateFrom);
      const toDate    = dayjs(total.dateTo);

      if (visitDate < fromDate || visitDate > toDate) continue;

      // only conflict if THE SAME field is non-zero in BOTH
      const sameAmountConflict  = visitHasAmount  && total.amount  > 0;
      const sameKmConflict      = visitHasKm      && total.km      > 0;
      const sameParkingConflict = visitHasParking && total.parking > 0;

      if (sameAmountConflict || sameKmConflict || sameParkingConflict) {
        return true;
      }
    }
  }
  return false;
}, [visits, totals]);

// checkBox for the submit button !! 
const handleSelectAllClick = (event) => {
  // If the user checked the master box...
  if (event.target.checked) {
    // Loop through only the visits as draft or rejected  and grab ONLY their entryNo IDs
    const newSelecteds = selectableRows.map((visit) => visit.entryNo);
    
    // Put all those IDs into our state array (checks all boxes)
    setSelectedIds(newSelecteds);
    return;
  }
  
  // If the user unchecked the master box, wipe the list clean (unchecks all boxes)
  setSelectedIds([]);
};

const handleClick = (event, entryNo) => {
  // Check if this specific entryNo is already in our selectedIds array
  // (.indexOf returns -1 if it CANNOT find the item)
  const selectedIndex = selectedIds.indexOf(entryNo);
  let newSelected = [];

  if (selectedIndex === -1) {
    // Scenario A: It's NOT in the list.
    // Create a new array containing all current selections, PLUS this new entryNo.
    newSelected = [...selectedIds, entryNo];
  } else {
    // Scenario B: It's ALREADY in the list (user wants to uncheck it).
    // Filter out this specific entryNo, keeping everything else.
    newSelected = selectedIds.filter((id) => id !== entryNo);
  }

  // Update our state with the updated list
  setSelectedIds(newSelected);
};
// should i show checkmark now!
// It looks for the entryNo inside the selectedIds array.
// If it finds it, it returns true (box gets checked).
// If it doesn't find it (returns -1), it returns false (box stays empty).
const isSelected = (entryNo) => selectedIds.indexOf(entryNo) !== -1;

// Select-all for Total Transportation cards
const handleSelectAllTotalsClick = (event) => {
  if (event.target.checked) {
    setSelectedTotalIds(selectableTotals.map((t) => t.entryNo));
    return;
  }
  setSelectedTotalIds([]);
};

// Toggle one Total Transportation card
const handleTotalClick = (entryNo) => {
  setSelectedTotalIds((prev) =>
    prev.indexOf(entryNo) === -1
      ? [...prev, entryNo]
      : prev.filter((id) => id !== entryNo)
  );
};

const isTotalSelected = (entryNo) => selectedTotalIds.indexOf(entryNo) !== -1;

    
const handleEditClick = (visit) => {
  console.log("[DEBUG] editing visit:", visit);
  setEditingRow(visit.entryNo);
  setEditValues({
    amount: visit.amount ?? "",
    km: visit.km ?? "",
    parking: visit.parking ?? "",
     comment: visit.comment ?? "",
  });
};

const handleSaveClick = async (entryNo) => {
  console.log("[DEBUG] saving entryNo:", entryNo, "values:", editValues)
  setSaving(true);
  try {
    const rawBase = localStorage.getItem("saved_sett_api_url");
    const API_BASE_URL =  normalizeBaseUrl(rawBase) || "http://localhost:5100";
    const stationId = getDeviceStationId();

    await apiFetch(`${API_BASE_URL}/api/visit/${entryNo}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: editValues.amount,
        km: editValues.km,
        parking: editValues.parking,
        comment: editValues.comment ?? "",
        empId: selectedEmpId,
        stationId,
        isPhone: isRealPhone(),
      }),
    });

    setEditingRow(null);
    // update_visit() freezes the old EntryNo (RecordStatusID=3) and
    // creates a brand-new active row with a NEW EntryNo — re-fetch
    // instead of patching local state under the now-stale id, or a
    // Submit right after editing will 404 like it just did for you.
    await fetchHistory();
  } catch (err) {
    console.error("Save failed:", err);
  } finally {
    setSaving(false);
  }
};

const handleDeleteTotal = async (entryNo) => {
  try {
    const rawBase = localStorage.getItem("saved_sett_api_url");
    const API_BASE_URL = normalizeBaseUrl(rawBase) || "http://localhost:5100";

    await apiFetch(`${API_BASE_URL}/api/visit/total/${entryNo}`, {
      method: "DELETE",
    });

    // remove from local state immediately — no need to re-fetch
    setTotals((prev) => prev.filter((t) => t.entryNo !== entryNo));
  } catch (err) {
    console.error("Delete failed:", err);
  }
};
//Define what makes a row eligible for submission
const canSubmitRow =(visit) => {
  const visitStatus = visit?.status ?? 0;
  // A row can ONLY be submitted if it's currently a Draft (0) or Rejected (3)
  // It blocks items that are already Pending (1), Approved (2), or Paid (4)
  return visitStatus === 0 || visitStatus === 3;
  // return visitStatus === 0 ;  //*to enable the select of paid and rejected 
};
// 2. Keep a memoized list of only the rows that can be submitted
const selectableRows = useMemo(() => {
  return visits.filter((visit) => canSubmitRow(visit));
}, [visits]);


//Define what makes a row eligible for Total submission
const canSubmitTotal =(total) => {
  const totalStatus = total?.status ?? 0;
  // A row can ONLY be submitted if it's currently a Draft (0) or Rejected (3)
  // It blocks items that are already Pending (1), Approved (2), or Paid (4)
  // return totalStatus === 0 || totalStatus === 3;
   return totalStatus === 0 ; //Draft Only 
};
// 2. Keep a memoized list of only the rows that can be submitted
const selectableTotals = useMemo(() => {
  return totals.filter((total) => canSubmitTotal(total));
}, [totals]);


const hasAmountOrKm = (row) => (Number(row.amount) || 0)> 0 || (Number(row.km) || 0) > 0;

// Guards the "Submit for Approval" button — blocks with a message
// instead of opening the confirm dialog if anything selected is
// missing both Amount and Km.
const handleSubmitClick = () => {
  const missingVisit = visits.some(
    (v) => selectedIds.includes(v.entryNo) && !hasAmountOrKm(v)
  );
  const missingTotal = totals.some(
    (t) => selectedTotalIds.includes(t.entryNo) && !hasAmountOrKm(t)
  );

  if (missingVisit || missingTotal ) {
    setSnack({
      open: true,
      message : "please fill in Amount or Km before submitting (Parking is optional).",
      severity: "error",
    });
    return;
  }
  setConfirmSubmitOpen(true);
};

// you can submit total trasportation and table visit in parallel 
const handleSubmit = async () => {
  setSubmitting(true);
  try {
    const rawBase = localStorage.getItem("saved_sett_api_url");
    const API_BASE_URL = normalizeBaseUrl(rawBase) || "http://localhost:5100";
    const month = selectedDate.month() + 1;
    const year  = selectedDate.year();

    const res = await apiFetch(`${API_BASE_URL}/api/visit/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        empId: selectedEmpId,
        month,
        year,
        selectedEntries: selectedIds, // <-- Sends the selected item IDs to backend, visit rows checked
        selectedTotalEntries:selectedTotalIds,  // total cards checked
      }),
    });

    const data = await res.json();
    
    if (res.ok) {
      setSnack({
        open: true,
        message: `Submitted ${data.submittedVisits || 0} visit(s) and ${data.submittedTotals || 0} total(s) for approval.`,
        severity: "success",
      });
      setSelectedIds([]);
      setSelectedTotalIds([]);
      await fetchHistory(); // refresh to show updated status badges
    } else {
      console.error("Submit failed:", data);
      setSnack({ open: true, message: data.error || "Submit failed.", severity: "error" });
    }
  } catch (err) {
    console.error("Submit error:", err);
    setSnack({ open: true, message: "Submit error. Check your connection.", severity: "error" });
  } finally {
    setSubmitting(false);
  }
};

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 4,
        px: 2,
        background: {
          xs: "linear-gradient(180deg, #e0f2f1 0%, #ffffff 40%)",
          md: "linear-gradient(135deg, #e0f2f1 0%, #ffffff 55%)",
        },
      }}
    >   
      <Paper
        elevation={10}
        sx={{
          width: "100%",
          maxWidth: 1100,
          p: 3,
          borderRadius: 4,
          overflow: "hidden",
          background: "linear-gradient(180deg, #ffffff 0%, #fbfffe 100%)",
          boxShadow: "0 20px 60px rgba(0,0,0,.12)",
          border: "1px solid #b2dfdb",
        }}
        
      >
      {/* warning ABOVE the card */}
        {conflictWarning && (
          <Box
            sx={{
              mb: 2,
              p: 1.5,
              borderRadius: 2,
              bgcolor: "#fff8e1",
              border: "1px solid #f9a825",
              display: "flex",
              alignItems: "flex-start",
              gap: 1.5,
            }}
          >
            <WarningAmberIcon sx={{ color: "#f9a825", mt: 0.2, flexShrink: 0 }} />
            <Typography variant="body2" sx={{ color: "#7b4f00", fontWeight: 600 }}>
              ⚠ You have non-zero amounts in both individual visit records and in the
              Total Transportation summary for overlapping dates. Please use only one
              method — either enter amounts per visit (in the table above) or enter a
              total summary (below), not both.
            </Typography>
          </Box>
        )}
        
        {/* Header row: icon + title on the left, summary chips on the right */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
          spacing={1.5}
        > */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            justifyContent="space-between"
            sx={{ mb: 2 }}
            spacing={1.5}
          >
          <Stack direction="row" alignItems="center" spacing={1}>
            <DirectionsCarIcon sx={{ color: "#00796b" }} />
            <Typography variant="h6" fontWeight={800} color="#004d40">
              Daily Visits
            </Typography>
          </Stack>

           {/* <Stack direction="row" spacing={1}>  */}
          {isMobile ? (
          <Stack spacing={1} sx={{ mb: 2 }}>
            <Chip
              icon={<GroupsIcon />}
              label={`Visits: ${totalVisits}`}
              color="primary"
              variant="outlined"
              size="small"
              sx={{
                borderColor: "#00796b",
                color: "#004d40",
                fontWeight: 700,
                width: "100%",
                justifyContent: "flex-start",
                py: 2,
              }}
            />

            <Box
              sx={{
                border: "1px solid #b2dfdb",
                borderRadius: 2,
                p: 1,
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Stack spacing={0.75}>
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totalAmount.toLocaleString()} L.L amount`}
                  sx={{
                    bgcolor: "#e8f5e9",
                    color: "#2e7d32",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totalKm.toLocaleString()} Km`}
                  sx={{
                    bgcolor: "#e3f2fd",
                    color: "#1565c0",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totalParking.toLocaleString()} L.L parking`}
                  sx={{
                    bgcolor: "#fff8e1",
                    color: "#e65100",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
              </Stack>
            </Box>
          </Stack>
        ) : (
            
          
           <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
            <Chip
              icon={<GroupsIcon />}
              label={`Visits: ${totalVisits}`}
              color="primary"
              variant="outlined"
              size="small"
              sx={{ borderColor: "#00796b", color: "#004d40", fontWeight: 700 }}
              
            />
            <Chip
            icon={<PaidIcon />}
                size="small"
                label={`Total Amount: ${totalAmount.toLocaleString()} L.L`}
                sx={{
                  bgcolor: "#e8f5e9",
                  color: "#2e7d32",
                  fontWeight: 500,
                  fontSize: 12,
                }}
                />
           
            <Chip
            icon={<PaidIcon />}
                size="small"
                label={`Total Kilometrage: ${totalKm.toLocaleString()} Km`}
                sx={{
                    bgcolor: "#e3f2fd",
                    color: "#1565c0",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                />
            
            <Chip
            icon={<PaidIcon />}
                size="small"
                label={`Total Parking: ${totalParking.toLocaleString()} L.L`}
                sx={{
                bgcolor: "#fff8e1",
                color: "#e65100",
                fontWeight: 500,
                fontSize: 12,
              }}
                />
           
          </Stack> 
          )}
          {/* right: month picker */}
          <DatePicker
            views={["year", "month"]}
            label="Month"
            value={selectedDate}
            onChange={(newVal) => { if (newVal) setSelectedDate(newVal); }}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  // width: 190,
                  // bgcolor: "white",
                  // borderRadius: 2,
                  width: { xs: "100%", sm: 190 },
                  bgcolor: "white",
                  borderRadius: 2,
                  "& .MuiInputBase-root": { fontSize: "0.75rem" },
                  "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                },
              },
            }}
          />
        </Stack>
      </LocalizationProvider>

      {/* employee selector for HR mode only */}
      {isHrMode && (
  <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
    <Autocomplete
      options={employees}
      getOptionLabel={(emp) => emp.fullName || ""}
      isOptionEqualToValue={(opt, val) => opt.empId === val.empId}
      onChange={(_, newVal) => setSelectedEmpId(newVal ? newVal.empId : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Employee"
          size="small"
          placeholder="Type to search..."
          sx={{ bgcolor: "white", borderRadius: 2 }}
        />
      )}
      sx={{ maxWidth: 400, flex: 1 }}
    />
    {/* <Button
      variant="outlined"
      startIcon={<AssessmentIcon />}
      onClick={() => navigate("/home/calendar/visit-report")}
      sx={{ borderColor: "#00796b", color: "#00796b", fontWeight: 700, textTransform: "none", whiteSpace: "nowrap" }}
    >
      Monthly Report
    </Button> */}
  </Stack>
)}
     
     {/* status banner — shows current month submission status */}
       {/* {monthStatus !== null && !isHrMode && (  */}
      
       {monthStatus !== null && (
  isMobile ? (
    // <Box
    //   sx={{
    //     mb: 2,
    //     p: 1.5,
    //     borderRadius: 2,
    //     bgcolor: "#e8f4f4",
    //     borderLeft: "4px solid #00796b",
    //   }}
    // >
      <Stack spacing={2}>
        <Chip
          label={`Selected: ${selectedIds.length} visit(s), ${selectedTotalIds.length} total(s)`}
          color="primary"
          variant="outlined"
          sx={{ fontWeight: 700, width: "100%", justifyContent: "flex-start", py: 2 }}
        />
   <Box
      sx={{
        mb: 2,
        p: 1,
        borderRadius: 2,
        bgcolor: "#e8f4f4",
        borderLeft: "4px solid #00796b"
      }}
    >

        <Stack spacing={0.75}>
  <Stack
    direction="row"
    spacing={0.5}
    sx={{
      overflowX: "auto",
      flexWrap: "nowrap",
      pb: 0.5,
      "&::-webkit-scrollbar": { height: 4 },
    }}
  >
    <Chip label={`Unsubmitted: ${statusCount[0] || 0}`} color="default" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
    <Chip label={`Pending: ${statusCount[1] || 0}`} color="warning" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
    <Chip label={`Approved: ${statusCount[2] || 0}`} color="success" variant="outlined" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
  </Stack>

  <Stack direction="row" spacing={0.5}>
    <Chip label={`Paid: ${statusCount[4] || 0}`} color="success" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24, bgcolor: "#2e7d32" }} />
    <Chip label={`Rejected: ${statusCount[3] || 0}`} color="error" variant="outlined" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
  </Stack>
</Stack>
</Box>
        {(selectableRows.length > 0 || selectableTotals.length > 0) && (
          <Tooltip title={isHrMode ? "HR can review, but only the employee can submit their own visits" : ""}>
            <span>
              <Button
                fullWidth
                variant="contained"
                size="medium"
                disabled={isHrMode || submitting || (selectedIds.length === 0 && selectedTotalIds.length === 0)}
                onClick={handleSubmitClick}
                startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: 2,
                  bgcolor: "#00796b",
                  py: 1.2,
                  "&:hover": { bgcolor: "#004d40" },
                }}
              >
                {submitting ? "Submitting..." : "Submit for Approval"}
              </Button>
            </span>
          </Tooltip>
        )}
      </Stack>
    // </Box>
  ) : (
    <Box
      sx={{
        mb: 2,
        p: 1.5,
        pl: 2,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1.5,
        bgcolor: "#e8f4f4",
        borderLeft: "4px solid #00796b"
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
        <Chip label={`Unsubmitted: ${statusCount[0] || 0 }`} color="default" variant="filled" sx={{ fontWeight: 700 }} />
        <Chip label={`Pending: ${statusCount[1] || 0 }`} color="warning" variant="filled" sx={{ fontWeight: 700 }} />
        <Chip label={`Approved: ${statusCount[2] || 0 }`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
        <Chip label={`Paid: ${statusCount[4] || 0}`} color="success" variant="filled" sx={{ fontWeight: 700, bgcolor: "#2e7d32" }} />
        <Chip label={`Rejected: ${statusCount[3] || 0 }`} color="error" variant="outlined" sx={{ fontWeight: 700 }} />
        <Chip label={`Selected: ${selectedIds.length} visit(s), ${selectedTotalIds.length} total(s)`} color="primary" variant="outlined" sx={{ fontWeight: 700 }} />
      </Stack>

      {(selectableRows.length > 0 || selectableTotals.length > 0) && (
        <Tooltip title={isHrMode ? "HR can review, but only the employee can submit their own visits" : ""}>
          <span>
            <Button
              variant="contained"
              size="small"
              disabled={isHrMode || submitting || (selectedIds.length === 0 && selectedTotalIds.length === 0)}
              onClick={handleSubmitClick}
              startIcon={submitting ? <CircularProgress size={14} color="inherit" /> : null}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: 2,
                bgcolor: "#00796b",
                px: 2.5,
                "&:hover": { bgcolor: "#004d40" },
              }}
            >
              {submitting ? "Submitting..." : "Submit for Approval"}
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  )
)}

        {/* ! Note we change the whole paper elevation to be responsive on mobile  */}
        {/* Table card, same elevation/radius pattern as AllAttendancePage */}
         {isMobile ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
             {/* Select all row for visits */}
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Checkbox
                  size="small"
                  checked={selectableRows.length > 0 && selectedIds.length === selectableRows.length}
                  indeterminate={selectedIds.length > 0 && selectedIds.length < selectableRows.length}
                  onChange={handleSelectAllClick}
                  sx={{ p: 0.3 }}
                />
                <Typography variant="caption" sx={{ color: "text.secondary" }}>Select all</Typography>
              </Stack>
              <Typography variant="caption" sx={{ color: "#004d40", fontWeight: 700, textTransform: "uppercase", fontSize: 11 }}>
                Visits
              </Typography>
              
            </Stack>

              {!visits.length && (
                <Typography variant="body2" sx={{ opacity: 0.5, color: "#004d40", textAlign: "center", py: 0.5 }}>
                  {isHrMode && !selectedEmpId ? "Select an employee to view their visits" : "No visits recorded"}
                </Typography>
              )}

              {visits.map((visit, index) => {
                const isItemSelected = isSelected(visit.entryNo);
                const visitStatus = visit.status ?? 0;
                const isSelectableRow = canSubmitRow(visit);
                const isEditing = editingRow === visit.entryNo;

                return (
                  <Paper
                    key={visit.entryNo || index}
                    elevation={1}
                    sx={{
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: isItemSelected ? "#00796b" : "#e0f2f1",
                      p: 1.5,
                    }}
                  >
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 0.5 }}>
                      <Typography variant="body2" fontWeight={700} sx={{ color: "#004d40" }}>
                        {visit.visitFrom} → {visit.visitTo}
                      </Typography>
                      <Chip
                        label={STATUS_CONFIG[visitStatus]?.label || "Unsubmitted"}
                        color={STATUS_CONFIG[visitStatus]?.color || "default"}
                        variant={STATUS_CONFIG[visitStatus]?.variant || "outlined"}
                        size="small"
                        sx={{ fontWeight: 700, fontSize: "0.65rem", height: 20 }}
                      />
                    </Stack>

                    <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1 }}>
                      {visit.date}
                      {(visit.timeIn || visit.timeOut) && (
                        <> · {visit.timeIn && visit.timeOut && visit.timeIn !== visit.timeOut
                          ? `${visit.timeIn} ~ ${visit.timeOut}`
                          : visit.timeIn || visit.timeOut}</>
                      )}
                    </Typography>

                    {isEditing ? (
                      <Stack spacing={1} sx={{ mb: 1 }}>
                        <TextField
                          size="small" label="Amount" type="number" fullWidth
                          value={editValues.amount}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, amount: e.target.value }))}
                          inputProps={{ min: 0, step: 50 }}
                        />
                        <TextField
                          size="small" label="Kilometrage" type="number" fullWidth
                          value={editValues.km}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, km: e.target.value }))}
                          inputProps={{ min: 0, step: 0.1 }}
                        />
                        <TextField
                          size="small" label="Parking" type="number" fullWidth
                          value={editValues.parking}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, parking: e.target.value }))}
                          inputProps={{ min: 0, step: 50 }}
                        />
                        <TextField
                          size="small" label="Comment" fullWidth
                          value={editValues.comment}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, comment: e.target.value }))}
                        />
                      </Stack>
                    ) : (
                      <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
                        <Typography variant="body2">{Number(visit.amount).toLocaleString()} L.L</Typography>
                        <Typography variant="body2">{visit.km} Km</Typography>
                        <Typography variant="body2">{Number(visit.parking).toLocaleString()} L.L park.</Typography>
                      </Stack>
                    )}

                    {/* {!isEditing && visit.comment && (
                      <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1 }}>
                        "{visit.comment}"
                      </Typography>
                    )} */}

                    {/* <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
                      {isEditing ? (
                        <IconButton size="small" color="success" onClick={() => handleSaveClick(visit.entryNo)} disabled={saving}>
                          {saving ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" />}
                        </IconButton>
                      ) : (
                        <Tooltip title={visit.status === 4 ? "Already paid - can no longer be edited" : "Edit"}>
                          <span>
                            <IconButton size="small" onClick={() => handleEditClick(visit)} disabled={visit.status === 4}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                      <Checkbox
                        size="small"
                        checked={isItemSelected}
                        disabled={!isSelectableRow}
                        onChange={(event) => handleClick(event, visit.entryNo)}
                      />
                    </Stack> */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Checkbox
                        size="small"
                        checked={isItemSelected}
                        disabled={!isSelectableRow}
                        onChange={(event) => handleClick(event, visit.entryNo)}
                      />
                      {isEditing ? (
                        <IconButton size="small" color="success" onClick={() => handleSaveClick(visit.entryNo)} disabled={saving}>
                          {saving ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" />}
                        </IconButton>
                      ) : (
                          <Tooltip title={visit.status === 4 ? "Already paid - can no longer be edited" : visit.status === 2 ? "Already approved - ask your supervisor to undo it first" : "Edit"}>
                          <span>
                            <IconButton size="small" onClick={() => handleEditClick(visit)} disabled={visit.status === 2 || visit.status === 4}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </Stack>

                    {!isEditing && visit.comment && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "60%",
                        }}
                      >
                        "{visit.comment}"
                      </Typography>
                    )}
                  </Stack>
                  </Paper>
                );
              })}
            </Box>
          ) : (
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: "auto", maxWidth: "100%" }}>
              <TableContainer sx={{ maxHeight: "70vh" }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox" sx={{ backgroundColor: "#004d40" }}>
                          <Checkbox
                            color="primary"
                            indeterminate={selectedIds.length > 0 && selectedIds.length < selectableRows.length}
                            checked={selectableRows.length > 0 && selectedIds.length === selectableRows.length}
                            onChange={handleSelectAllClick}
                            disabled={selectableRows.length === 0}
                            sx={{ 
                              color: "white", 
                              "&.Mui-checked": { color: "#80cbc4" }, 
                              "&.MuiCheckbox-indeterminate": { color: "#80cbc4" } 
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold", minWidth: 70, textAlign:"center" }}>
                          Visit From 
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold", minWidth: 70, textAlign:"center" }}>
                          Visit To 
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Date
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Time
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Amount (L.L)
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Kilometrage (Km)
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Parking (L.L)
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Comment
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Status
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", borderLeft: "1px solid #004d40", textAlign:"center" }}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {visits.map((visit, index) => {
                        const isItemSelected = isSelected(visit.entryNo); 
                        const visitStatus = visit.status ?? 0;
                        const isSelectable = canSubmitRow(visit);
                        const isEditing = editingRow === visit.entryNo;
                        return (
                          <TableRow key={visit.entryNo || index} selected={isItemSelected} hover sx={{ "& td": { fontSize: { xs: 12, sm: 13 }, py: 0.9, px: 1.5 }, backgroundColor: index % 2 === 0 ? "#f1fdfb" : "transparent" }}>
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                disabled={!isSelectable}
                                onChange={(event) => handleClick(event, visit.entryNo)}
                              />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#004d40", textAlign:"center" }}>
                              {visit.visitFrom}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "#004d40", textAlign:"center" }}>
                              {visit.visitTo}
                            </TableCell>
                            <TableCell>{visit.date}</TableCell>
                            <TableCell>
                              {visit.timeIn && visit.timeOut && visit.timeIn !== visit.timeOut
                                ? `${visit.timeIn} ~ ${visit.timeOut}`
                                : visit.timeIn || visit.timeOut || "—"
                              }
                            </TableCell>
                            <TableCell align="center">
                              {isEditing ? (
                                <TextField size="small" type="number" value={editValues.amount}
                                  onChange={(e) => setEditValues((prev) => ({ ...prev, amount: e.target.value }))}
                                  inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }} sx={{ width: 110, textAlign:"center" }} />
                              ) : (
                                Number(visit.amount).toLocaleString()
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {isEditing ? (
                                <TextField size="small" type="number" value={editValues.km}
                                  onChange={(e) => setEditValues((prev) => ({ ...prev, km: e.target.value }))}
                                  inputProps={{ min: 0, step: 0.1, style: { textAlign: "center" } }} sx={{ width: 80 }} />
                              ) : (
                                visit.km
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {isEditing ? (
                                <TextField size="small" type="number" value={editValues.parking}
                                  onChange={(e) => setEditValues((prev) => ({ ...prev, parking: e.target.value }))}
                                  inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }} sx={{ width: 90 }} />
                              ) : (
                                Number(visit.parking).toLocaleString()
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {isEditing ? (
                                <TextField
                                  size="small"
                                  type="text"
                                  value={editValues.comment}
                                  onChange={(e) => setEditValues((prev) => ({ ...prev, comment: e.target.value }))}
                                  sx={{ width: 130 }}
                                />
                              ) : (
                                visit.comment || "—"
                              )}
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={STATUS_CONFIG[visitStatus]?.label || "Unsubmitted"}
                                color={STATUS_CONFIG[visitStatus]?.color || "default"}
                                variant={STATUS_CONFIG[visitStatus]?.variant || "outlined"}
                                size="small"
                                sx={{ fontWeight: 700, fontSize: "0.7rem", height: 24 }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              {isEditing ? (
                                <IconButton size="small" color="success" onClick={() => handleSaveClick(visit.entryNo)} disabled={saving}>
                                  {saving ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" />}
                                </IconButton>
                              ) : (
                                 <Tooltip title={visit.status === 4 ? "Already paid - can no longer be edited" : visit.status === 2 ? "Already approved - ask your supervisor to undo it first" : "Edit"}>
                                  <span>
                                    <IconButton size="small" onClick={() => handleEditClick(visit)} disabled={visit.status === 2 || visit.status === 4}>
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {/* {!visits.length && (
                        <TableRow>
                          <TableCell colSpan={7} sx={{ textAlign: "center", height: 25, p: 0, border: 0 }}>
                            <Box sx={{ height: 25, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.5 }}>
                              <Typography variant="body2" fontWeight={600} sx={{ color: "#004d40" }}>
                                {isHrMode && !selectedEmpId
                                  ? "Select an employee to view their visits"
                                  : "No visits recorded"
                                }
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )} */}
                      {!visits.length && (
                      <TableRow>
                        <TableCell colSpan={11} sx={{ textAlign: "center", height: 25, p: 0, border: 0 }}>
                          <Box sx={{ height: 25, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.5 }}>
                            <Typography variant="body2" fontWeight={600} sx={{ color: "#004d40" }}>
                              {isHrMode && !selectedEmpId
                                ? "Select an employee to view their visits"
                                : "No visits recorded"
                              }
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                    </TableBody>
                  </Table>
              </TableContainer>
            </Paper>
          )}

        {/* ── Summary of Total Transportation ─────────────────────────────── */}
       
   
      {/* Summary of Total Transportation — always visible */}
      <Box sx={{ mt: 3 }}>

          {/* Header row: title + totals + edit button */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={1.5}
            sx={{ mb: 1.5 }}
          >
            {/* Left: icon + title */}
             <Stack direction="row" alignItems="center" spacing={1}>
            <DirectionsBusIcon sx={{ color: "#00796b" }} />
            <Typography variant="h6" fontWeight={800} color="#004d40">
               Group Visits: Transportation
            </Typography>
          </Stack>

            {/* Right: total chips + select all + edit button */}
            {/* <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap"> */}
            {isMobile ? (
            <Stack spacing={1} sx={{ width: "100%" }}>
            <Box
              sx={{
                border: "1px solid #b2dfdb",
                borderRadius: 2,
                p: 1,
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Stack spacing={0.75}>
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totals.reduce((s, t) => s + (Number(t.amount) || 0), 0).toLocaleString()} L.L amount`}
                  sx={{
                    bgcolor: "#e8f5e9",
                    color: "#2e7d32",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totals.reduce((s, t) => s + (Number(t.km) || 0), 0)} Km`}
                  sx={{
                    bgcolor: "#e3f2fd",
                    color: "#1565c0",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
                <Chip
                  icon={<PaidIcon />}
                  size="small"
                  label={`${totals.reduce((s, t) => s + (Number(t.parking) || 0), 0).toLocaleString()} L.L parking`}
                  sx={{
                    bgcolor: "#fff8e1",
                    color: "#e65100",
                    fontWeight: 500,
                    fontSize: 11,
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                />
              </Stack>
            </Box>

            <Button
              size="medium"
              onClick={() => setTotalDialogOpen(true)}
              variant="outlined"
              startIcon={<EditIcon />}
              sx={{
                borderColor: "#00796b",
                color: "text.primary",
                fontWeight: 700,
                textTransform: "none",
              "&:hover": { borderColor: "#004d40", backgroundColor: "#e0f2f1" },
              }}
            >
             Edit Group Transportation
            </Button>
           
          </Stack>
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            flexWrap="wrap"
            useFlexGap
            sx={{ width: { xs: "100%", sm: "auto" }, rowGap: 1 }}
          >
            {/* {totals.length > 0 && (
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Checkbox
                  size="small"
                  checked={selectableTotals.length > 0 && selectedTotalIds.length === selectableTotals.length}
                  indeterminate={selectedTotalIds.length > 0 && selectedTotalIds.length < selectableTotals.length}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedTotalIds(selectableTotals.map((t) => t.entryNo));
                    } else {
                      setSelectedTotalIds([]);
                    }
                  }}
                  disabled={selectableTotals.length === 0}
                  sx={{ p: 0.3 }}
                />
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  Select all
                </Typography>
              </Stack>
            )} */}

            <Chip
              icon={<PaidIcon />}
              size="small"
              label={`${totals.reduce((s, t) => s + (Number(t.amount) || 0), 0).toLocaleString()} L.L amount`}
              sx={{
                bgcolor: "#e8f5e9",
                color: "#2e7d32",
                fontWeight: 500,
                fontSize: 12,
              }}
            />

            <Chip
              icon={<PaidIcon />}
              size="small"
              label={`${totals.reduce((s, t) => s + (Number(t.km) || 0), 0)} Km`}
              sx={{
                bgcolor: "#e3f2fd",
                color: "#1565c0",
                fontWeight: 500,
                fontSize: 12,
              }}
            />

            <Chip
              icon={<PaidIcon />}
              size="small"
              label={`${totals.reduce((s, t) => s + (Number(t.parking) || 0), 0).toLocaleString()} L.L parking`}
              sx={{
                bgcolor: "#fff8e1",
                color: "#e65100",
                fontWeight: 500,
                fontSize: 12,
              }}
            />

            <Button
              size="medium"
              onClick={() => setTotalDialogOpen(true)}
              variant="outlined"
              startIcon={<EditIcon />}
              sx={{
                borderColor: "#00796b",
                color: "text.primary",
                fontWeight: 700,
                textTransform: "none",
              "&:hover": { borderColor: "#004d40", backgroundColor: "#e0f2f1" },
              }}
            >
              Edit Total Transportation
            </Button>
          </Stack>
        )}
          </Stack>

          {/* status banner — shows current month submission status */}
      {/* {monthStatus !== null && !isHrMode && ( */}   
      {monthStatus !== null && (
        isMobile ? (
          <>
            <Box
              sx={{
                mb: 2,
                p: 1.5,
                borderRadius: 2,
                bgcolor: "#e8f4f4",
                borderLeft: "4px solid #00796b",
              }}
            >
              <Stack spacing={0.75}>
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{
                    overflowX: "auto",
                    flexWrap: "nowrap",
                    pb: 0.5,
                    "&::-webkit-scrollbar": { height: 4 },
                  }}
                >
                  <Chip label={`Unsubmitted: ${totalStatusCount[0] || 0}`} color="default" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
                  <Chip label={`Pending: ${totalStatusCount[1] || 0}`} color="warning" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
                  <Chip label={`Approved: ${totalStatusCount[2] || 0}`} color="success" variant="outlined" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
                </Stack>

                <Stack direction="row" spacing={0.5}>
                  <Chip label={`Paid: ${totalStatusCount[4] || 0}`} color="success" variant="filled" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24, bgcolor: "#2e7d32" }} />
                  <Chip label={`Rejected: ${totalStatusCount[3] || 0}`} color="error" variant="outlined" size="small" sx={{ fontWeight: 700, fontSize: 11, height: 24 }} />
                </Stack>
              </Stack>
            </Box>

            {/* {totals.length > 0 && (
              <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 2 }}>
                <Checkbox
                  size="small"
                  checked={selectableTotals.length > 0 && selectedTotalIds.length === selectableTotals.length}
                  indeterminate={selectedTotalIds.length > 0 && selectedTotalIds.length < selectableTotals.length}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedTotalIds(selectableTotals.map((t) => t.entryNo));
                    } else {
                      setSelectedTotalIds([]);
                    }
                  }}
                  disabled={selectableTotals.length === 0}
                  sx={{ p: 0.3 }}
                />
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  Select all
                </Typography>
              </Stack>
            )} */}
          </>
        ) : (
          <Box
            sx={{
              mb: 2,
              p: 1.5,
              pl: 2,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.5,
              bgcolor: "#e8f4f4",
              borderLeft: "4px solid #00796b"
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
              <Chip label={`Unsubmitted: ${totalStatusCount[0] || 0 }`} color="default" variant="filled" sx={{ fontWeight: 700 }} />
              <Chip label={`Pending: ${totalStatusCount[1] || 0 }`} color="warning" variant="filled" sx={{ fontWeight: 700 }} />
              <Chip label={`Approved: ${totalStatusCount[2] || 0 }`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
              <Chip label={`Paid: ${totalStatusCount[4] || 0}`} color="success" variant="filled" sx={{ fontWeight: 700, bgcolor: "#2e7d32" }} />
              <Chip label={`Rejected: ${totalStatusCount[3] || 0 }`} color="error" variant="outlined" sx={{ fontWeight: 700 }} />
            </Stack>
          </Box>
        )
      )}
        {totals.length > 0 ? (
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: 1.5 }}>
            {totals.map((t) => {
              const totalStatus = t.status ?? 0;
              const isTotalSelectable = canSubmitTotal(t);
              const isTotalChecked = isTotalSelected(t.entryNo);

              return (
                <Paper
                  key={t.entryNo}
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    borderLeft: "4px solid #00796b",
                    overflow: "hidden",
                    outline: isTotalChecked ? "2px solid #00796b" : "none",
                    outlineOffset: "-1px",
                    transition: "outline 0.15s ease",
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: "#004d40",
                      px: 1.5,
                      py: 0.8,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {!isMobile && (
                      <Checkbox
                        size="small"
                        checked={isTotalChecked}
                        disabled={!isTotalSelectable}
                        onChange={() => handleTotalClick(t.entryNo)}
                        sx={{
                          p: 0.3,
                          color: "white",
                          "&.Mui-checked": { color: "#80cbc4" },
                          "&.Mui-disabled": { color: "rgba(255,255,255,0.3)" },
                        }}
                      />
                    )}
                    
                    {/* {!isHrMode && ( */}
                      {/* <Checkbox
                        size="small"
                        checked={isTotalChecked}
                        disabled={!isTotalSelectable}
                        onChange={() => handleTotalClick(t.entryNo)}
                        sx={{
                          p: 0.3,
                          color: "white",
                          "&.Mui-checked": { color: "#80cbc4" },
                          "&.Mui-disabled": { color: "rgba(255,255,255,0.3)" },
                        }}
                      /> */}
                    {/* )} */}
                    <Typography variant="body2" fontWeight={700} sx={{ color: "white", flex: 1 }}>
                      {t.dateFrom} → {t.dateTo}
                    </Typography>

                    <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Chip
                      label={STATUS_CONFIG[totalStatus]?.label || "Unsubmitted"}
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: 10,
                        fontWeight: 500,
                        bgcolor: "#dbd3b8",
                        color: "#bc6333",
                        "& .MuiChip-label": { px: 0.75 },
                      }}
                    />
                    <Tooltip title="Delete">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteTotal(t.entryNo)}
                          disabled={!isTotalSelectable}
                          sx={{
                            color: "white",
                            opacity: isTotalSelectable ? 0.8 : 0.3,
                            "&:hover": { opacity: 1, bgcolor: "rgba(255,255,255,0.15)" },
                            p: 0.3,
                          }}
                        >
                          <DeleteRoundedIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    </Stack>
                  </Box>
                    {/* <Chip
                      label={STATUS_CONFIG[totalStatus]?.label || "Draft"}
                      color={STATUS_CONFIG[totalStatus]?.color || "default"}
                      // variant={STATUS_CONFIG[totalStatus]?.variant || "outlined"}
                      variant="filled"
                      size="small"
                      sx={{ fontWeight: 700, fontSize: "0.65rem", height: 20 }}
                    />
                    <Tooltip title="Delete">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteTotal(t.entryNo)}
                          disabled={!isTotalSelectable}
                          sx={{
                            color: "white",
                            opacity: isTotalSelectable ? 0.8 : 0.3,
                            "&:hover": { opacity: 1, bgcolor: "rgba(255,255,255,0.15)" },
                            p: 0.3,
                          }}
                        >
                          <DeleteRoundedIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box> */}
                  <Stack direction="row" divider={<Box sx={{ width: "1px", bgcolor: "#e0f2f1" }} />}>
                    <Box sx={{ flex: 1, p: 1.5, textAlign: "center" }}>
                      <Typography variant="caption" sx={{ color: "#00796b", fontWeight: 600, display: "block", mb: 0.3 }}>Amount</Typography>
                      <Typography variant="body2" fontWeight={800} sx={{ color: "#004d40" }}>{Number(t.amount).toLocaleString()} L.L</Typography>
                    </Box>
                    <Box sx={{ flex: 1, p: 1.5, textAlign: "center" }}>
                      <Typography variant="caption" sx={{ color: "#00796b", fontWeight: 600, display: "block", mb: 0.3 }}>Kilometrage</Typography>
                      <Typography variant="body2" fontWeight={800} sx={{ color: "#004d40" }}>{t.km} Km</Typography>
                    </Box>
                    <Box sx={{ flex: 1, p: 1.5, textAlign: "center" }}>
                      <Typography variant="caption" sx={{ color: "#00796b", fontWeight: 600, display: "block", mb: 0.3 }}>Parking</Typography>
                      <Typography variant="body2" fontWeight={800} sx={{ color: "#004d40" }}>{Number(t.parking).toLocaleString()} L.L</Typography>
                    </Box>
                  </Stack>
                </Paper>
              );
            })}
          </Box>
        ) : (
          <Typography variant="body2" sx={{ opacity: 0.5, color: "#004d40", mt: 1 }}>
            No total transportation records for this month
          </Typography>
        )}
      </Box>


    </Paper>

    <EditTotalTransportationDialog
      open={totalDialogOpen}
      onClose={() => setTotalDialogOpen(false)}
      onSaved={fetchHistory}
      selectedDate={selectedDate}
      empId={selectedEmpId}
       totals={totals}
    />

    <Snackbar
      open={snack.open}
      autoHideDuration={4000}
      onClose={() => setSnack((s) => ({ ...s, open: false }))}
      message={snack.message}
    />

    {/* Confirm submit dialog — same idea/design as the delete confirmation */}
    <Dialog
      open={confirmSubmitOpen}
      onClose={() => setConfirmSubmitOpen(false)}
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle>Submit for approval?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          You're about to submit {selectedIds.length} visit(s) and {selectedTotalIds.length} total(s)
          to your supervisor for approval. You won't be able to edit them until they're
          reviewed. Are you sure you want to continue?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2.5 }}>
        <Button onClick={() => setConfirmSubmitOpen(false)}>Cancel</Button>
        <Button
          color="primary"
          variant="contained"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={14} color="inherit" /> : null}
          onClick={async () => {
            setConfirmSubmitOpen(false);
            await handleSubmit();
          }}
          sx={{ bgcolor: "#00796b", "&:hover": { bgcolor: "#004d40" } }}
        >
          {submitting ? "Submitting..." : "Yes, Submit"}
        </Button>
      </DialogActions>
    </Dialog>

  </Box>
  );
}
